import store from '@/store/index'

/**
 * Routes de pages publiques (Login, Unauthorized, Error500)
 * et routes spécifiques à l'authentification OIDC.
 */

/**
 * Routes publiques communes à toutes les compagnies.
 */
export const commonPageRoutes = [
  {
    name: 'Login',
    meta: {
      isPublic: true,
      roles: ['*'],
    },
    path: 'login',
    component: () => import('@/views/pages/Login'),
  },
  {
    name: 'unauthorized',
    meta: {
      isPublic: true,
      roles: ['*'],
    },
    path: 'unauthorized',
    component: () => import('@/views/pages/Unauthorized'),
  },
  {
    name: 'error500',
    meta: {
      isPublic: true,
      roles: ['*'],
    },
    path: '/error500',
    component: () => import('@/views/pages/Error500'),
  },
]

/**
 * Routes additionnelles pour l'authentification OIDC (uqam).
 */
export const oidcPageRoutes = [
  {
    name: 'oidcCallback',
    meta: {
      isOidcCallback: true,
      isPublic: true,
      roles: ['*'],
    },
    path: '/oidc-callback',
    component: () => import('@/views/OIDC/OidcCallback.vue'),
  },
  {
    name: 'oidcCallbackError',
    meta: {
      isPublic: true,
      roles: ['*'],
    },
    path: '/oidc-callback-error',
    component: () => import('@/views/OIDC/OidcCallbackError.vue'),
  },
  {
    name: 'protected',
    meta: {
      roles: ['admin'],
    },
    path: '/protected',
    component: () => import('@/views/OIDC/Protected.vue'),
  },
]

/**
 * Pour OIDC (uqam) : la route Login redirige si déjà authentifié.
 */
export function getLoginRouteWithOidcGuard () {
  return {
    name: 'Login',
    meta: {
      isPublic: true,
      roles: ['*'],
    },
    path: 'login',
    component: () => import('@/views/pages/Login'),
    beforeEnter: (to, from, next) => {
      if (store.getters['oidcStore/oidcIsAuthenticated']) {
        next('/')
      } else {
        next()
      }
    },
  }
}

/**
 * Construit les routes de pages selon le type d'authentification.
 * @param {'msal'|'oidc'} authType
 * @returns {Object[]}
 */
export function getPageRoutes (authType) {
  if (authType === 'oidc') {
    // Remplace la route Login par celle avec le guard OIDC
    const loginRoute = getLoginRouteWithOidcGuard()
    const otherRoutes = commonPageRoutes.filter(r => r.name !== 'Login')
    return [loginRoute, ...otherRoutes, ...oidcPageRoutes]
  }
  return [...commonPageRoutes]
}
